import parse, { DomElement, domToReact } from "html-react-parser";
import React, { ReactElement } from "react";
import styled from "styled-components";

import Link from "../shared/Link";
import ListComponent from "../shared/ListComponent";
import Text from "../shared/Text";

interface FieldCopyProps {
  htmlString?: string | null;
}

const FieldCopy: React.FC<FieldCopyProps> = ({ htmlString }) => {
  const options = {
    replace: (node: DomElement) => {
      switch (node.name) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
        case "p":
          // Replace headings / paragraphs with Text
          if (node.children) {
            return (
              <Text as={node.name}>{domToReact(node.children, options)}</Text>
            );
          }
          break;
        case "strong":
        case "b":
          // Replace bold tags with bold Text
          if (node.children) {
            return (
              <Text bold={true}>{domToReact(node.children, options)}</Text>
            );
          }
          break;
        case "a":
          // replace anchor tags with our link component
          if (node.children && node.attribs?.href) {
            return (
              <Link to={node.attribs.href}>
                {domToReact(node.children, options)}
              </Link>
            );
          }
          break;
        case "ul":
          // replace anchor tags with our link component
          if (node.children) {
            return (
              <ListComponent>
                {domToReact(node.children, options)}
              </ListComponent>
            );
          }
          break;
        case "img":
          // Not allowed - return an empty div
          return <div />;
        default:
          // Default - just return the input
          return;
      }
    },
  };

  if (htmlString) {
    return <Wrapper>{parse(htmlString, options) as ReactElement}</Wrapper>;
  } else {
    return null;
  }
};

const Wrapper = styled.div`
  p {
    padding-bottom: 0.5rem;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
`;

export default FieldCopy;
